import { c as _c } from "react/compiler-runtime";
import type { PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { useStore } from '@/components/playbook-builder';
import type { Data } from '@/components/playbook-builder/hooks/use-store';
import TestMode from '../../test-mode';

// A draft has no committed PlaybookVersionNoGraph, so synthesize one from the store to reuse the
// version-aware test flow. `version` is unused — a draft is always run by its in-progress version id.
const buildDraftVersion = ({
  obcId,
  key,
  playbookId,
  settings
}: Data): PlaybookVersionNoGraph => ({
  id: obcId ?? '',
  key: key ?? '',
  playbookId: playbookId ?? '',
  name: settings.name,
  kind: settings.kind,
  requiresAuthentication: settings.requiresAuthentication,
  requiredAuthMethods: settings.requiredAuthMethods,
  prerequisites: [],
  hasBoKyc: false,
  hasAuthenticationNode: false,
  promptForPasskey: settings.promptForPasskey,
  isModern: settings.isModern,
  settings,
  version: 0,
  createdAt: '',
  isDeployed: false,
  isExecutable: true,
  isGraphSourceOfTruth: true,
  isImmutable: false,
  status: 'enabled'
});

/**
 * Test button for a draft. Routes KYC/document drafts to the onboarding flow and KYB/bank-linking to the
 * legacy flow (same as the committed editor), addressing the playbook by its in-progress version id.
 */
const DraftTestMode = () => {
  const $ = _c(8);
  const {
    data,
    visibleBanners
  } = useStore();
  let t0;
  if ($[0] !== visibleBanners) {
    t0 = visibleBanners.some(_temp);
    $[0] = visibleBanners;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasErrors = t0;
  let t1;
  if ($[2] !== data) {
    t1 = buildDraftVersion(data);
    $[2] = data;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== data.obcId || $[5] !== hasErrors || $[6] !== t1) {
    t2 = <TestMode selectedVersion={t1} hasPendingChanges={true} hasErrors={hasErrors} versionId={data.obcId} />;
    $[4] = data.obcId;
    $[5] = hasErrors;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default DraftTestMode;
function _temp(banner) {
  return banner.type === "error";
}